import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-quotes',
    templateUrl: './quotes.component.html',
    styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {

    public project_id: any = {};
    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public sentiment = 0;
    public country = '';
    public checked_sm: any = { all: false, twitter: true, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false };
    page: number = 1;
    total: number = 0;
    page_length: number = 9;
    hide: boolean = true;
    public blocked_items: any = {};

    public countries: any = {};

    public pages = [];
    public load_more = true;

    public selected: any = {};
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    ranges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 3 Month': [moment().subtract(3, 'month'), moment()]
    };

    constructor(private router: Router, private service: DashboardService, private login: LoginService, private route: ActivatedRoute, private spinner: NgxSpinnerService, lc: NgZone) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.service.setTitle('Quotes | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
        this.alwaysShowCalendars = true;
        this.keepCalendarOpeningWithRange = true;
        this.selected = { startDate: login.get_session_data('ieye_session_start_date'), endDate: login.get_session_data('ieye_session_end_date') };
        this.countries = this.get_countries();
    }

    ngOnInit(): void {
        let page = this.page + 1;
        this.pageChanged(page);
    }

    onScroll() {
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', this.page_length, this.page);
    }

    public async get_countries() {
        this.result = await this.service.get_actions({}, 'countries');
        this.countries = this.result;
    }

    datesUpdated(range) {
        this.page = 1;
        this.total = 0;
        if (range.startDate != null && range.endDate != null) {
            this.service.saveDateRange(moment(range.startDate._d).format("YYYY-MM-DD"), moment(range.endDate._d).format("YYYY-MM-DD"));
            this.selected = { startDate: this.login.get_session_data('ieye_session_start_date'), endDate: this.login.get_session_data('ieye_session_end_date') };
            this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', this.page_length, this.page);
        }
    }

    public sentimant_filter(sentiment) {
        this.sentiment = sentiment;
        this.page = 1;
        this.total = 0;
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', this.page_length, this.page);
    }

    public pageChanged(page) {
        this.page = page;
        //        this.total = (this.page * this.page_length) + this.page_length;
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', this.page_length, this.page);
    }

    public async get_mentions(start, end, mention_type, page_length, page_no) {
        this.spinner.show();
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", mention_type);
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", page_length);
        formData.append("page_no", page_no);
        formData.append("pager", this.total);
        formData.append("sentiment", this.sentiment);
        formData.append("sort", 'rank');
        formData.append("country", this.country);
        formData.append("channels[twitter]", this.checked_sm.twitter);
        formData.append("channels[facebook]", this.checked_sm.facebook);
        formData.append("channels[instagram]", this.checked_sm.instagram);
        formData.append("channels[web]", this.checked_sm.web);
        formData.append("channels[youtube]", this.checked_sm.youtube);
        formData.append("channels[reviews]", this.checked_sm.reviews);
        formData.append("channels[others]", this.checked_sm.others);
        formData.append("channels[all]", this.checked_sm.all);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.total = this.result.count;
            this.hide = this.result.hide;
            //            this.pages = this.result.data.mentions;
            this.pages = this.pages.concat(this.result.data.mentions);
            this.spinner.hide();

            this.blocked_items.mentions = this.result.user.blocked_mentions;
            this.blocked_items.profiles = this.result.user.blocked_profiles;
            this.load_more = true;
            //            window.scroll(0, 0);
        }
    }

    public change_date_format(date, format) {
        return moment.tz(date, 'Asia/Muscat').utc().format(format);
    }

    public viewQuote(mention) {
        Swal.fire({
            title: 'Author: ' + mention.name,
            showCloseButton: true,
            showConfirmButton: false,
            customClass: {
                container: 'quote_popup'
            },
            html: '<div class="left_side"><img src="' + mention.profile_image + '"></br><span class="name">' + mention.name + '</span></br><span class="followers_count">' + mention.followers_count + ' Followers</span></div><div class="right_side"><p>' + mention.description + '</p></div><div class="bottom_side"><div class="sm_icon"><img src="' + this.get_social_icon(mention.mchannel) + '"></div><div class="information"><span>Page Rank : ' + mention.profile_meta_count1 + '</span></div></div>'
        });
    }

    public get_social_icon(channel) {
        switch (channel) {
            case 'web': {
                return 'assets/images/icons/share-2.svg';
                break;
            }
            case 'facebook': {
                return 'assets/images/icons/facebook.svg';
                break;
            }
            case 'instagram': {
                return 'assets/images/icons/instagram.svg';
                break;
            }
            case 'twitter': {
                return 'assets/images/icons/twitter.svg';
                break;
            }
            case 'youtube': {
                return 'assets/images/icons/youtube.svg';
                break;
            }
            case 'linkedin': {
                return 'assets/images/icons/linkedin.svg';
                break;
            }
            default: {
                return 'assets/images/icons/share-2.svg';
                break;
            }
        }
    }

    public country_filter(code, type) {
        var country_data = this.countries.filter(x => x.cca2 == code);
        return country_data.length != 0 ? country_data[0][type] : '';
    }


    public can_show_mention(id, profile_id) {
        var mentions = JSON.stringify(this.blocked_items.mentions);
        var profiles = JSON.stringify(this.blocked_items.profiles);
        if (mentions.indexOf(id) !== -1 || profiles.indexOf(profile_id) !== -1) {
            return 'none';
        }
        return 'block';
    }

}
